var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMediaHk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 20,
    viewBox: "0 0 77 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3274_15462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5237 2.21461C35.5237 1.54794 34.9514 1.16699 34.3809 1.16699H22.3809V2.30985H32.5704V4.97652C32.5704 6.02413 32.4752 6.97652 32.1904 7.83366H20.1895V9.07175H27.2371V11.3575H22.1895V12.5003H32.5695V18.6908H34.2856C35.1418 18.6908 35.5237 18.4041 35.5237 17.4518V12.4041C35.5237 11.7375 35.0476 11.3565 34.4752 11.3565H30.1895V9.07175H37.5228V7.83366H34.6656C35.1418 7.16699 35.5228 5.9289 35.5228 4.88128L35.5237 2.21461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1429 12.5947H3.80957C4.09528 12.8804 4.18957 13.5471 4.18957 14.1185V17.4519C4.18957 18.5947 4.57148 18.8804 5.71433 18.8804H16V17.7376H7.04767V12.5947H7.1429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7619 2.30897H6.85619V0.785156H3.61905C3.80952 0.975632 3.90476 1.54706 3.90476 2.02325V2.30897H0V3.45182H2.57048C1.42857 4.21373 0.665714 5.45182 0.665714 6.97563C0.665714 9.54706 2.85714 11.3566 5.33238 11.3566C7.90381 11.3566 9.99905 9.54706 10.0943 6.97563C10.0943 5.45182 9.33238 4.21373 8.18952 3.45182H10.761V2.30897H10.7619ZM5.33333 10.2137C4 10.2137 3.14286 8.88039 3.14286 7.07087C3.14286 5.16611 3.99905 3.92801 5.33333 3.92801C6.66762 3.92801 7.52381 5.26135 7.52381 7.07087C7.52286 8.88039 6.66667 10.2137 5.33333 10.2137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 1.16699H12C12.2857 1.45271 12.381 2.11937 12.381 2.6908V13.7384H14.0952C14.9514 13.7384 15.3333 13.3575 15.3333 12.5003V6.59556H18.1905V5.45271H15.3333C15.3333 5.35747 15.3333 1.16699 15.3333 1.16699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3335 1.16699C73.7135 1.45271 73.9049 2.11937 73.9049 2.6908V18.8813H75.2383C76.1906 18.8813 76.5706 18.3098 76.5706 17.3575V1.16699H73.3335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0002 6.78604H67.1431V7.9289H70.0002V17.167H71.2383C72.1907 17.167 72.5707 16.5956 72.5707 15.5479V1.16699H69.4278C69.8088 1.45271 69.904 2.11937 69.904 2.6908L70.0002 6.78604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8095 2.97586C49.9047 2.3092 49.5238 1.83301 48.8571 1.83301H41.0476V3.0711H46.8571C46.8571 7.26158 44.2866 9.92824 40.0952 10.6901L40.6666 11.4521C46.0943 10.7854 49.3333 8.21396 49.8095 2.97586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8097 1.16699H52.4764C52.8573 1.45271 52.9526 2.11937 52.9526 2.6908V4.02414H49.9049V5.26223H52.9526V6.88128H49.8097V8.02413H52.9526V10.786C52.1907 10.5003 51.3335 10.3098 50.4764 10.3098C47.6192 10.3098 45.2383 12.2146 45.2383 14.8813C45.2383 17.6422 47.6192 19.4527 50.4764 19.4527C53.3335 19.4527 55.7145 17.5479 55.8097 14.8813C55.8097 14.7851 55.8097 14.7851 55.8097 14.6908V1.16699ZM50.4764 18.2146C48.9516 18.2146 47.9049 16.8813 47.9049 14.8813C47.9049 12.8803 48.9526 11.5479 50.4764 11.5479C52.0002 11.5479 53.0469 12.8803 53.0469 14.8813C53.0469 16.8813 52.0002 18.2146 50.4764 18.2146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9988 2.88063C67.9988 2.11872 67.5226 1.83301 66.9512 1.83301H60.0941V3.0711H65.1417C65.1417 6.69015 62.5702 9.0711 58.856 10.4044C62.9512 11.0711 65.9988 13.0711 68.0941 16.0225V12.4035C66.3788 11.0711 64.4741 10.3082 62.6655 10.0225C65.4274 8.88063 67.9988 5.35682 67.9988 2.88063Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3274_15462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.5705,
    height: 18.6672,
    fill: "white",
    transform: "translate(0 0.785156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMediaHk);
export default __webpack_public_path__ + "static/media/ic_media_hk.264d9b4a4105c2c53ec67a5b86c8a345.svg";
export { ForwardRef as ReactComponent };